import React from "react"
import propTypes from "prop-types"

import useClickOutside from "../hooks/useClickOutside"
import Search from "./HeaderIcons/Search"

import "./SearchPopup.scss"

const SearchPopup = ({
  setIsSearchVisible,
  handleKeyPress,
  setQuery,
  query,
}) => {
  const clickRef = React.useRef()

  useClickOutside(clickRef, () => {
    setIsSearchVisible(false)
  })

  return (
    <div className="search-popup">
      <div className="search-popup__container" ref={clickRef}>
        <input
          type="text"
          className="search-popup__container__input"
          value={query}
          onKeyUp={handleKeyPress}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
        />
        <div
          onClick={() => {
            window.location.href = `/search?q=${query}`
          }}
        >
          <Search />
        </div>
      </div>
    </div>
  )
}

SearchPopup.propTypes = {
  setIsSearchVisible: propTypes.func.isRequired,
  handleKeyPress: propTypes.func.isRequired,
  setQuery: propTypes.func.isRequired,
  query: propTypes.string.isRequired,
}

export default SearchPopup
